import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { RadioGroupComponent } from './radio-group.component';

@NgModule({
    declarations: [
        RadioGroupComponent
    ],
    exports: [
        RadioGroupComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class RadioGroupModule { }
